const createHtmlBlock = (SirTrevor) => {
  SirTrevor.Blocks.Html = SirTrevor.Block.extend({
    type: 'Html',
    editorHTML:
      '<textarea readonly class="st-text-block st-textarea-block"></textarea>',
    loadData: function (data) {
      this.initialText = data.text || '';
    },
    onBlockRender: function () {
      this.getTextBlock()[0].value = this.initialText || '';
    },
    _serializeData: function () {
      return {
        format: 'Html',
        text: this.getTextBlock()[0].value,
      };
    },
  });
};
export { createHtmlBlock };
